import React from "react";
// nodejs library that concatenates classes
import classNames from "classnames";
// @material-ui/core components
import withStyles from "@material-ui/core/styles/withStyles";

// @material-ui/icons

// core components
import Header from "components/Header/Header.jsx";
import Footer from "components/Footer/Footer.jsx";
import GridContainer from "components/Grid/GridContainer.jsx";
import GridItem from "components/Grid/GridItem.jsx";
// import Button from "components/CustomButtons/Button.jsx";
import HeaderLinks from "components/Header/HeaderLinks.jsx";
import Parallax from "components/Parallax/Parallax.jsx";

import landingPageStyle from "assets/jss/material-kit-react/views/landingPage.jsx";

// Sections for this page
import ProductSection from "./Sections/ProductSection.jsx";
import ProductSection1 from "./Sections/ProductSection1.jsx";
import TeamSection from "./Sections/TeamSection.jsx";

const dashboardRoutes = [];

class LandingPage extends React.Component {
  componentDidMount() {
    window.scrollTo(0, 0)
  }

  buttonClick = (link) => {
    if (link === 'home') {
      this.props.history.push('home')
    } else if (link === 'about') {
      this.props.history.push('about')
    } else if (link === 'newsresources') {
      this.props.history.push('newsresources')
    } else if (link === 'service') {
      this.props.history.push('service')
    } else if (link === 'career') {
      this.props.history.push('career')
    } else if (link === 'getintouch') {
      this.props.history.push('getintouch')
    } else if (link === 'gallery') {
      this.props.history.push('gallery')
    } else {
      this.props.history.push('/')
    }
  }
  render() {
    const { classes, ...rest } = this.props;
    return (
      <div>
        <Header
          color="transparent"
          routes={dashboardRoutes}
          brand="SANDTON CONSULTING"
          rightLinks={<HeaderLinks onButtonClick={this.buttonClick} />}
          fixed
          changeColorOnScroll={{
            height: 10,
            color: "primary"
          }}
          {...rest}
        />
        <Parallax filter image={require("assets/img/landing-bg.jpg")}>
          <div className={classes.container}>
            <GridContainer>
              <GridItem xs={12} sm={12} md={6}>
                <h1 className={classes.title}>About Us</h1>
                <h4>
                  We provide quality management solution. Unleashing your organisation’s full potentials.
                </h4>
                <br />
              </GridItem>
            </GridContainer>
          </div>
        </Parallax>
        <div style={{ backgroundColor: '#F0FDF9' }} className={classNames(classes.main, classes.mainRaised)}>
          <div className={classes.container}>
            <ProductSection />
            {/* <TeamSection /> */}
          </div>
        </div>
        <br />
        <br />
        <div style={{ backgroundColor: 'white' }} className={classNames(classes.main, classes.mainRaised)}>
          <div className={classes.container}>
            <ProductSection1 />
            {/* <TeamSection /> */}
          </div>
        </div>
        <br />
        <br />
        <div style={{ backgroundColor: '#F0FDF9' }} className={classNames(classes.main, classes.mainRaised)}>
          <div className={classes.container}>
            <TeamSection />
          </div>
        </div>
        <Footer />
      </div>
    );
  }
}

export default withStyles(landingPageStyle)(LandingPage);



// WEBPACK FOOTER //
// ./src/views/AboutPage/LandingPage.jsx